import { createContext, useContext } from 'react';

/**
 * Estado del panel derecho en /album: comprimido (default) o expandido.
 * Cuando está expandido, el sidebar absorbe parte del espacio que antes
 * ocupaban columnas de países, y la cantidad de columnas absorbidas
 * depende del view:
 *   - 'dashboard'  → álbum cae a 3 columnas (panel grande con dashboard).
 *   - 'collectors' → álbum cae a 4 columnas (panel intermedio con la
 *                    lista completa de coleccionistas).
 *
 * onCreateOffer: callback para lanzar el flujo VIEW_OFFER_BUILDER desde
 * dentro del dashboard embebido sin romper la jerarquía de props.
 */
export const AlbumDashboardContext = createContext({
  expanded: false,
  expandedView: 'dashboard',
  setExpanded: () => {},
  openExpandedView: () => {},
  onCreateOffer: null,
});

export function useAlbumDashboard() {
  return useContext(AlbumDashboardContext);
}
